import React, { useState, useEffect } from 'react';
import { FiInstagram, FiSend, FiPhone, FiAward } from 'react-icons/fi';
import { trainerAPI, achievementAPI } from '../../api/services';
import TrainerDetailsModal from '../../components/public/TrainerDetailsModal';
import { useTranslation } from 'react-i18next';

const IMAGES = [
  'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=400&q=80',
  'https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?w=400&q=80',
  'https://images.unsplash.com/photo-1549719386-74dfcbf7dbed?w=400&q=80',
  'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=400&q=80',
  'https://images.unsplash.com/photo-1574680096145-d05b474e2155?w=400&q=80',
  'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=400&q=80',
];

const TrainersPage = () => {
  const [trainers, setTrainers] = useState([]);
  const [achievements, setAchievements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTrainer, setSelectedTrainer] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    Promise.all([
      trainerAPI.getAll(),
      achievementAPI.getAll()
    ]).then(([trainerRes, achievementRes]) => {
      setTrainers(trainerRes.data?.data || []);
      setAchievements(achievementRes.data?.data || []);
    })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      {selectedTrainer && (
        <TrainerDetailsModal 
          trainer={selectedTrainer} 
          achievements={achievements} 
          onClose={() => setSelectedTrainer(null)} 
        />
      )}
      <div className="page-header">
        <div className="container">
          <img src="/illustrations/trainer.png" alt="Trainers" className="page-header-illustration" />
          <span className="section-label">{t('trainers_page.label')}</span>
          <h1>{t('trainers_page.title')}</h1>
          <p>{t('trainers_page.subtitle')}</p>
        </div>
      </div>

      <section className="section" style={{ paddingTop: 32 }}>
        <div className="container">
          {loading ? (
            <div className="loading"><div className="spinner"></div></div>
          ) : trainers.length === 0 ? (
            <div className="empty-state">
              <div className="icon">🏋️</div>
              <h3>{t('trainers_page.no_trainers')}</h3>
              <p>{t('trainers_page.updating')}</p>
            </div>
          ) : (
            <div className="grid-4">
              {trainers.map((trainer, i) => {
                const trainerAchievements = achievements.filter(a => a.trainerId === trainer.id);
                
                return (
                  <div key={trainer.id} className="card trainer-card" onClick={() => setSelectedTrainer(trainer)} style={{ cursor: 'pointer' }}>
                    <img src={trainer.mediaUrl || IMAGES[i % IMAGES.length]} alt={trainer.fullName} className="card-img" style={{ height: 250 }} />
                    <div className="card-body trainer-info">
                      <h3>{trainer.fullName}</h3>
                      <p className="position">{trainer.position}</p>
                      {trainer.age && <p style={{ color: 'var(--text-muted)', fontSize: '0.8rem', marginBottom: 8 }}>{t('trainers_page.age')}: {trainer.age}</p>}
                      
                      {trainerAchievements.length > 0 && (
                        <div style={{ marginTop: 12 }}>
                          <p style={{ fontSize: '0.7rem', fontWeight: 700, textTransform: 'uppercase', color: 'var(--text-muted)', letterSpacing: '0.05em', marginBottom: 6 }}>{t('trainers_page.achievements')}</p>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                            {trainerAchievements.map(ach => (
                              <div key={ach.id} className="trainer-achievement" style={{ margin: 0 }}>
                                <FiAward style={{ flexShrink: 0 }} />
                                <span className="line-clamp-1" title={ach.description}>{ach.name}</span>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      <div className="trainer-socials" style={{ marginTop: 16 }}>
                        {trainer.instagramLink && (
                          <a href={trainer.instagramLink} target="_blank" rel="noopener noreferrer" className="trainer-social"><FiInstagram /></a>
                        )}
                        {trainer.telegramLink && (
                          <a href={trainer.telegramLink} target="_blank" rel="noopener noreferrer" className="trainer-social"><FiSend /></a>
                        )}
                        {trainer.phone && (
                          <a href={`tel:${trainer.phone}`} className="trainer-social"><FiPhone /></a>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default TrainersPage;
